/**
 * BillingPage
 * Props:
 *   plan — { name, rateLabel, usedFeeds, totalFeeds, forecast, forecastDate }
 *   paymentMethod — { brand, last4, expiry }
 *   invoices — [{ id, periodLabel, amountLabel, status }]
 *   onChangePlan()
 *   onUpdatePayment()
 *   onDownloadInvoice(id)
 */
export default function BillingPage({ plan, paymentMethod, invoices = [], onChangePlan, onUpdatePayment, onDownloadInvoice }) {
  const usagePct = plan ? Math.min(100, Math.round((plan.usedFeeds / plan.totalFeeds) * 100)) : 0;

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <p style={{ fontWeight: 500, fontSize: "var(--text-lg)", margin: "0 0 12px" }}>Current plan</p>
        <div className="ical-card" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <p style={{ margin: 0, fontSize: "var(--text-base)", fontWeight: 500 }}>{plan?.name} · {plan?.rateLabel}</p>
            <p style={{ margin: 0, fontSize: "var(--text-xs)", color: "var(--text-secondary)" }}>
              {plan?.usedFeeds?.toLocaleString()} / {plan?.totalFeeds?.toLocaleString()} feeds · forecast: {plan?.forecast?.toLocaleString()} by {plan?.forecastDate}
            </p>
          </div>
          <button className="ical-btn" onClick={onChangePlan}>Change plan</button>
        </div>
        <div style={{ height: 6, borderRadius: 3, background: "var(--border)", overflow: "hidden", marginTop: 10 }}>
          <div style={{ height: "100%", width: `${usagePct}%`, background: "var(--fill-accent)" }} />
        </div>
      </div>

      <div style={{ marginBottom: 20 }}>
        <p style={{ fontWeight: 500, fontSize: "var(--text-lg)", margin: "0 0 12px" }}>Payment method</p>
        <div className="ical-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: "var(--text-sm)" }}>
            {paymentMethod?.brand} ending in {paymentMethod?.last4} · expires {paymentMethod?.expiry}
          </span>
          <button className="ical-btn" style={{ padding: "6px 12px", fontSize: "var(--text-xs)" }} onClick={onUpdatePayment}>Update</button>
        </div>
      </div>

      <div>
        <p style={{ fontWeight: 500, fontSize: "var(--text-lg)", margin: "0 0 12px" }}>Invoices</p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 100px 90px 32px", gap: 12, padding: "6px 12px", fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>
          <span>Period</span><span>Amount</span><span>Status</span><span />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {invoices.map((inv) => (
            <div key={inv.id} className="ical-row" style={{ display: "grid", gridTemplateColumns: "1fr 100px 90px 32px", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: "var(--text-sm)" }}>{inv.periodLabel}</span>
              <span style={{ fontSize: "var(--text-sm)" }}>{inv.amountLabel}</span>
              <span className={`ical-badge ${inv.status === "Paid" ? "ical-badge-success" : "ical-badge-warning"}`}>{inv.status}</span>
              <button type="button" onClick={() => onDownloadInvoice?.(inv.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)" }} aria-label="Download invoice">
                ↓
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
